module.exports = __webpack_public_path__ + "static/img/syicon_1.8c5c51a6.svg";